/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function BentPlanes(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/planes.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane006.geometry}
        material={materials['Material.009']}
        position={[-1.71, 1.47, -2.62]}
        rotation={[1.42, -0.61, -1.26]}
        scale={[0.54, 0.64, 0.24]}
      >
        <meshStandardMaterial
          color="#00CDE7"
          opacity={0.7}
          transparent={true}
        />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane007.geometry}
        material={materials['Material.008']}
        position={[-1.82, -0.68, -0.4]}
        scale={0.26}
      >
        <meshStandardMaterial color="#FFFFFF" opacity={1} transparent={false} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane008.geometry}
        material={materials['Material.007']}
        position={[-1.62, -1.39, -1.08]}
        rotation={[0, 0.96, 0]}
        scale={0.42}
      >
        <meshStandardMaterial color="#00CDE7" opacity={1} transparent={false} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane009.geometry}
        material={materials.Material}
        position={[2.0, -0.92, -4.64]}
        scale={0.45}
      >
        <meshStandardMaterial color="#00CDE7" opacity={1} transparent={false} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane010.geometry}
        material={materials['Material.010']}
        position={[2.03, 1.28, -4.25]}
        rotation={[0.02, 0.36, 0.4]}
        scale={[0.32, 0.66, 0.71]}
      >
        <meshStandardMaterial color="#FFFFFF" opacity={1} transparent={false} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/planes.glb')
